import React from "react";

export default function TestComponent({ name }) {
  return (
    <div className='flex flex-col gap-2 items-center justify-center bg-gray-200 p-4 rounded-md'>
      Test Component

      <p className='text-sm text-gray-500'>
        {name}
      </p>
    </div>
  );
}
